import 'apps/pathways/styles/start/components/result.scss';
import React from 'react';
import { resolve } from 'library/helpers/path-resolver';
import PropTypes from 'prop-types';
import ResultModal from 'apps/pathways/start/components/result-modal';
import ThumbUpSvg from 'library/icons/thumb-up.svg';
import ThumbDownSvg from 'library/icons/thumb-down.svg';

class Result extends React.Component {
  state = {
    modal: false,
    liking: false,
    renderModal: false
  }

  openModal = () => {
    this.setState({
      modal: true,
      renderModal: true
    });
  }

  closeModal = () => {
    this.setState({
      modal: false,
      renderModal: false
    });
  }

  likeCareer = async () => {
    this.setState({
      liking: true
    });
    if (resolve(this.props, 'data/liked', false)) {
      return this.neutralizeCareer();
    }
    await this.props.like(resolve(this.props, 'data/id', null));
    this.setState({
      liking: false
    });
  }
  dislikeCareer = async () => {
    this.setState({
      liking: true
    });
    if (resolve(this.props, 'data/disliked', false)) {
      return this.neutralizeCareer();
    }
    await this.props.dislike(resolve(this.props, 'data/id', null));
    this.setState({
      liking: false
    });
  }
  neutralizeCareer = async () => {
    this.setState({
      liking: true
    });
    await this.props.neutralize(resolve(this.props, 'data/id', null));
    this.setState({
      liking: false
    });
  }

  render() {
    const {
      data,
      loading=false,
      buildPathway,
      hideMatchScores
    } = this.props;

    return (
      <div className="pathways-start-result" disabled={loading||data.loading}>
        <div className="pathways-start-result-title">
          <span>
            {
              data.loading
                ? 'Loading'
                : data.title
            }
          </span>
        </div>
        { data.loading || hideMatchScores || Math.round(data.match) < 1 ?
          null :
          <div className="pathways-start-result-match">
            <span>{ Math.round(data.match) }% Match</span>
          </div>
        }
        <div className="pathways-start-result-description">
          { resolve(data, 'description', '').slice(0,315) }
        </div>

        <div className="pathways-start-result-like-dislike">
          <div className="pathways-start-result-like-dislike-options">
            <a
              aria-label={`This is an option to like the career ${data.title},
                           it is currently ${data.liked ? 'liked' : data.disliked ? 'disliked' : 'not liked or disliked'},
                           press enter to ${data.liked ? 'unlike' : 'like'}`}
              disabled={this.state.liking}
              onClick={this.likeCareer}
              className={resolve(data, 'disliked', null)?'active':''}
              href="javascript:void(0)">
              <ThumbUpSvg />
            </a>
            <a
              aria-label={`This is an option to dislike the career ${data.title},
                          it is currently ${data.liked ? 'liked' : data.disliked ? 'disliked' : 'not liked or disliked'},
                          press enter to ${data.disliked ? 'undislike' : 'dislike'}`}
              disabled={this.state.liking}
              onClick={this.dislikeCareer}
              className={resolve(data, 'liked', null)?'active':''}
              href="javascript:void(0)">
              <ThumbDownSvg />
            </a>
          </div>
          <span  className="pathways-start-result-like-dislike-label">
            Like This Career
          </span>
        </div>

        <div className="pathways-start-result-footer">
          <span>CAREER</span>
          <a aria-label={`Open Modal for ${data.title}`} href="javascript:void(0)" onClick={this.openModal} disabled={loading||data.loading}>more info</a>
        </div>

        {this.state.renderModal ?
          <ResultModal
            buildPathway={buildPathway}
            closeModal={this.closeModal}
            onClose={this.closeModal}
            active={this.state.modal}
            data={data}
          /> : null }

      </div>
    );
  }
}

Result.propTypes = {
  data: PropTypes.object,
  graph_loading: PropTypes.bool,
  dislike: PropTypes.func,
  like: PropTypes.func,
  loading: PropTypes.bool,
  neutralize: PropTypes.func,
  buildPathway: PropTypes.func,
  hideMatchScores: PropTypes.bool
};

export default Result;
